module.exports = __webpack_public_path__ + "static/media/mh.ec211b56.svg";